import makeBreadcrumbs from "../../shared/containers/make_breadcrumbs";

import { overviewClick, parameterClick } from "../actions/focus_view";

const segmentDefinitions = [
  ["overview", overviewClick, false],
  ["parameter", parameterClick, true]
];

export default makeBreadcrumbs(segmentDefinitions);
